import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const CreateTabapayAuthTransfer = gql`
  mutation CreateTabapayAuthTransfer(
    $idempotencyId: IdempotencyToken!
    $input: CreateTabapayAuthTransferInput!
  ) {
    createTabapayAuthTransfer(idempotencyId: $idempotencyId, input: $input) {
      ... on CreateTabapayAuthTransferSuccess {
        __typename
        transactionId
        isChallengeRequired
      }

      ... on CreateTabapayAuthTransferError {
        __typename
        ...error
      }

      ... on TabaPayCustomError {
        __typename
        ...tabaPayError
      }
    }
  }
  ${error}
  ${tabaPayError}
`;

export default CreateTabapayAuthTransfer;
